export const KEYS_QUERY = 'keys';
export const ORDERS_QUERY = 'orders';
export const QUOTES_QUERY = 'quotes';
export const USER_QUERY = 'user';
export const SHOP_QUERY = 'shops';
export const SHOP_EDIT_QUERY = 'shops_edit';
